import {HttpClient, HttpClientModule} from '@angular/common/http';
import {APP_INITIALIZER, ErrorHandler, LOCALE_ID, NgModule} from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { JoyrideModule } from 'ngx-joyride';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {HttpJWTInterceptorProvider} from './modules/shared/interceptors/jwt.interceptor';
import { LayoutModule } from './layout/layout.module';
import {HttpHeaderURLInterceptorProvider} from "./modules/shared/interceptors/http.interceptor";
import {HttpErrorInterceptorProvider} from "./modules/shared/interceptors/httpError.interceptor";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {AlertService} from "./modules/shared/services/alert.service";
import '@angular/common/locales/global/pl';
import {GoogleMapsModule} from "@angular/google-maps";
import {PixelModule} from "ngx-pixel";
import {NgxGoogleAnalyticsModule, NgxGoogleAnalyticsRouterModule} from "ngx-google-analytics";
import {SubscriptionService} from "./modules/app/global/billings/services/subscription.service";
import {LoadingService} from "./modules/shared/services/loading.service";
import {NgSelectModule} from "@ng-select/ng-select";
import * as Sentry from "@sentry/angular";
import {Router} from "@angular/router";
import {RestaurantService} from "./modules/shared/services/restaurant.service";
import {LanguagesService} from "./modules/shared/services/languages.service";
import {ActionReducer, MetaReducer, StoreModule} from "@ngrx/store";
import {localStorageSync} from "ngrx-store-localstorage";
import {sessionAwareStorage} from "./modules/shared/services/local-storage.service";
import {EffectsModule} from "@ngrx/effects";
import {StoreEffects} from "./modules/shared/store/store.effects";
import {storeStateReducer} from "./modules/shared/store/store.reducer";
import {CompanyService} from "./modules/shared/services/company.service";
import {ContactFormComponent} from "./auth/account/contact-form/contact-form.component";
import {FormsModule} from "@angular/forms";
import {ContactFormSuccessComponent} from "./auth/account/contact-form-success/contact-form-success.component";
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/lang/', '.json?v=' + Math.random());
}

export function initializeApp(restaurantService: RestaurantService) {
    return (): Promise<any> => {
        return restaurantService.initializeData();
    }
}

export function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
    return localStorageSync({keys: ['store'], storageKeySerializer: (key) => `fodimi_spa_${key}`, rehydrate: true, storage: sessionAwareStorage})(reducer);
}
const metaReducers: Array<MetaReducer<any, any>> = [localStorageSyncReducer];


@NgModule({
    declarations: [
        AppComponent,
        ContactFormComponent,
        ContactFormSuccessComponent
    ],
    imports: [
        FormsModule,
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        JoyrideModule.forRoot(),
        SweetAlert2Module.forRoot(),
        AppRoutingModule,
        LayoutModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            },
            defaultLanguage: 'pl'
        }),
        StoreModule.forRoot( {store: storeStateReducer} , {metaReducers}),
        EffectsModule.forRoot([StoreEffects]),
        GoogleMapsModule,
        PixelModule.forRoot({ enabled: true, pixelId: '374800657918224' }),
        NgxGoogleAnalyticsModule.forRoot('G-BKE0F229EN'),
        NgxGoogleAnalyticsRouterModule,
        NgSelectModule
    ],
    providers: [
        Title,
        HttpJWTInterceptorProvider,
        HttpHeaderURLInterceptorProvider,
        HttpErrorInterceptorProvider,
        AlertService,
        {
            provide: LOCALE_ID,
            useValue: 'pl-PL',
        },
        SubscriptionService,
        LoadingService,
        LanguagesService,
        {
            provide: ErrorHandler,
            useValue: Sentry.createErrorHandler({
                showDialog: false,
            }),
        },
        {
            provide: Sentry.TraceService,
            deps: [Router],
        },
        {
            provide: APP_INITIALIZER,
            useFactory: initializeApp,
            deps: [RestaurantService, Sentry.TraceService],
            multi: true
        },
        CompanyService
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
